export default "__VITE_ASSET__HNW$NiB6__"